import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
export var sendPrivacyPolicySelectedEvent = function sendPrivacyPolicySelectedEvent(evt) {
  sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_action: 'Newsletter click',
    event_category: 'Footer',
    event_label: 'privacy policy'
  });
};